import { Component, OnInit, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AddressByGeoLocation } from 'src/app/models/Response/AddressByGeoLocation';
import { ApiService } from 'src/app/services/api.service';
import { GeoLocationService } from 'src/app/services/geo-location-service.service';
import { UtilserviceService } from 'src/app/services/utilservice.service';
import { jhcassoAPIUri } from 'src/environments/apiUri';

@Component({
  selector: 'app-savelocation',
  templateUrl: './savelocation.page.html',
  styleUrls: ['./savelocation.page.scss'],
})
export class SavelocationPage implements OnInit {

  @Input() item: any;

  displayAddress: string = '';
  selectedAddress: AddressByGeoLocation = {} as AddressByGeoLocation;

  constructor(
    private modal: ModalController,
    private api: ApiService,
    private util: UtilserviceService,
    private geoLocationService: GeoLocationService
  ) { }

  ngOnInit() {

    this.displayAddress =
      this.item?.fullAddressInfo ||
      this.item?.formatted_address ||
      this.item?.address ||
      this.item?.street ||
      '';

    this.selectedAddress = {
      city: this.item?.city,
      state: this.item?.state,
      country: this.item?.country,
      let: this.item?.let,
      long: this.item?.long,
      fullAddressInfo: this.displayAddress,
      addressId: this.item?.addressId || null
    };
  }

  closeOnly() {
    this.modal.dismiss();
  }

  async confirmSelection() {

    if (!this.item) {
      this.util.warningToast('Invalid address');
      return;
    }

    const data = {
      street:
        this.item.street ||
        this.item.fullAddressInfo ||
        this.item.formatted_address ||
        '',

      city: this.item.city,
      state: this.item.state,
      country: this.item.country,

      let: String(this.item.let),
      long: String(this.item.long)
    };

    this.util.startLoad();

    this.api.postDataWithToken(
      jhcassoAPIUri.address,
      data,
      'V1'
    ).subscribe({

      next: async (response: any) => {

        this.util.dismissLoader();

        if (response?.status) {

          const savedAddress = {
            ...this.selectedAddress,
            addressId: response.data?.addressId
          };

          await this.geoLocationService.setAddressInfo(savedAddress);

          this.modal.dismiss({
            selectedAddress: savedAddress
          });

        } else {
          this.util.warningToast('Unable to save address');
        }
      },

      error: () => {
        this.util.dismissLoader();
        this.util.warningToast('Server error');
      }
    });
  }
}